import { useFlow } from "@edreamsodigeo/frontend-core";

interface useToolsInterface {
  isMobile: boolean;
  isDesktop: boolean;
}

export const useTools = (): useToolsInterface => {
  const flow = useFlow();

  const isMobile = flow === "mobile";

  return { isMobile, isDesktop: !isMobile };
};
